import { getRestUrl } from 'shared/helpers/url'

export const getDownloadPdfUrl = ({
  exportId,
  groupId,
  projectId,
  token
}: {
  exportId: string
  groupId: string
  projectId: string
  token: string
}): string =>
  getRestUrl(
    `export/pdf/${encodeURIComponent(
      exportId
    )}?groupId=${encodeURIComponent(
      groupId
    )}&projectId=${encodeURIComponent(
      projectId
    )}&token=${encodeURIComponent(token)}`
  )

export const downloadPdf = ({
  exportId,
  groupId,
  projectId,
  token
}: {
  exportId: string
  groupId: string
  projectId: string
  token: string
}) => {
  const link = document.createElement('a')
  link.href = getDownloadPdfUrl({
    exportId,
    groupId,
    projectId,
    token
  })
  link.download = 'file.pdf'
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
